var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.impact)?_c('ix-section',[_c('ix-section-text',[(_vm.impactGoal)?_c('nuxt-child',{attrs:{"venture-id":_vm.ventureId,"impact":_setup.impact,"impact-goal":_vm.impactGoal}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }